import { Component, Input, OnInit } from "@angular/core";
import { TenantSurveyStatusChangeHistory } from "src/app/shared/models/survey";

@Component({
    selector: "submission-history",
    templateUrl: "./submission-history.component.html",
    styleUrls: ["./submission-history.component.scss"],
    standalone: false
})
export class SubmissionHistoryComponent implements OnInit {
  @Input() administrativeUnitSurveyHistories: TenantSurveyStatusChangeHistory[] = [];

  constructor() {}

  ngOnInit(): void {}
}
